<div class="splash-container">
  <div>
    <button class="btn btn-primary btn-lg" (click)="login()">Log in</button>
  </div>
</div>
